import styled from 'styled-components';

export const Frontend = styled.div`
  @media (max-width: 959px) {
    background: #fff;
    height: 100%;
  }
`;
